import { excelDownload } from "js/commonExcel";
import React from "react";

export default function ExcelButton({ label = "Excel", style, columns, data, fileName, sheetName, disabled = false  }) {
	const buttonClassName = `table-btn btn-excel ${disabled ? ' disabled' : ''}`;
    return (
        <button onClick={() => excelDownload(columns, data, fileName, sheetName)} className={buttonClassName} style={style} disabled={disabled}>
            {label}
        </button>
    );
}